<template>
  <div class="trading-box">
    <a-card :bordered="false" :bodyStyle="{ padding: 0 }">
      <div class="head-opera-box">
        <a-button class="editable-add-btn" @click="handleDown"
          >批量下架</a-button
        >
        <a-input-search
          placeholder="请输入yy号"
          @search="onSearch"
          enterButton="搜索"
          style="width:500px"
        />
      </div>
      <a-table
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: haoSelect
        }"
        @change="change"
        :columns="columns"
        :dataSource="haolist"
        :pagination="pagination"
        :rowKey="haolist => haolist.hao"
      >
        <div slot="status" slot-scope="record">
          <a-tag color="green">
            <span v-statusHao="record.hao_status"></span>
          </a-tag>
        </div>
        <div slot="action" slot-scope="record" class="opera-btn-box">
          <a-button
            type="primary"
            size="small"
            href="javascript:;"
            @click="showDetail(record)"
            >详情</a-button
          >
          <a-popconfirm
            :title="'你确定要下架YY号：' + record.hao + '吗?'"
            okText="下架"
            cancelText="取消"
            @confirm="downOne(record)"
          >
            <a-button type="primary" size="small" href="javascript:;"
              >下架</a-button
            >
          </a-popconfirm>
        </div>
      </a-table>
      <!-- 下架提示 -->
      <a-modal
        title="下架提示"
        :visible="visible"
        @ok="downMore"
        @cancel="downMoreCancel"
        :confirmLoading="confirmLoading"
      >
        <p>{{ downContent }}</p>
      </a-modal>
      <!-- 下架提示 -->
      <a-modal
        title="下架提示"
        :visible="visibleDown"
        @ok="downMore"
        @cancel="downMoreCancel"
        :confirmLoading="confirmLoading"
      >
        <p>请输入要下架的YY号 一行一个YY号</p>
        <a-textarea
          :style="{ height: '300px' }"
          v-model="downContent2"
        ></a-textarea>
      </a-modal>
      <!-- 详情提示 -->
      <a-modal
        title="账号详情"
        :visible="visibleDetail"
        @ok="downMoreCancel"
        @cancel="downMoreCancel"
        :confirmLoading="confirmLoading"
      >
        <div>
          <p>YY号:{{ haoDetail.hao }}</p>
          <p>等级:{{ haoDetail.grade }}</p>
          <p>价格:{{ haoDetail.price }}</p>
        </div>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import { HAO_onsale_query, HAO_down } from "@/api/hao";
import "@/utils/directive";
const columns = [
  {
    title: "YY号",
    dataIndex: "hao"
  },
  {
    title: "等级",
    dataIndex: "grade"
  },
  {
    title: "价格",
    dataIndex: "price"
  },
  {
    title: "状态",
    key: "hao_status",
    scopedSlots: { customRender: "status" },
    align: "center"
  },
  {
    title: "操作",
    key: "operation",
    scopedSlots: { customRender: "action" },
    align: "center"
  }
];
export default {
  data() {
    return {
      haolist: [],
      haoDetail: {},
      columns,
      current: 1,
      total: 0,
      limit: 10,
      selectedRowKeys: [],
      searchValue: "",
      visible: false,
      downContent: "",
      downContent2: "",
      confirmLoading: false,
      visibleDetail: false,
      visibleDown: false,
      pagination: {
        total: 0,
        pageSize: 10,
        showTotal: total => `总数: ${total} 条`
      }
    };
  },
  computed: {
    rowSelection() {
      return {
        type: "checkbox"
      };
    }
  },
  mounted() {
    this.getHao({
      skip: 0,
      limit: 10
    });
  },
  methods: {
    getHao: function(_obj) {
      HAO_onsale_query(_obj)
        .then(response => {
          this.selectedRowKeys = [];
          this.haolist = response.res.data;
          this.pagination.total = response.res.total;
          this.pagination.pageSize = response.res.limit;
          // this.current = response.res.skip / this.limit + 1;
        })
        .catch(() => {});
    },
    haoSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleDown: function() {
      if (this.selectedRowKeys.length > 0) {
        this.downContent = "";
        this.downContent += "你确定要下架这些号码吗?";
        this.visible = true;
      } else {
        // this.$notification.warning({
        //   message: "提示",
        //   description: "请选择要下架的号码"
        // });
        this.downContent2 = "";
        this.visibleDown = true;
      }
    },
    downMoreCancel: function() {
      this.visible = false;
      this.visibleDetail = false;
      this.visibleDown = false;
    },
    downMore: function() {
      this.confirmLoading = true;
      let b = [];
      if (this.visibleDown) {
        this.downContent2 = this.downContent2.trim();
        if (this.downContent2.indexOf("\r\n") > -1) {
          b = this.downContent2.split("\n");
        } else {
          b = this.downContent2.split("\n");
        }
      } else {
        this.selectedRowKeys.forEach(item => {
          b.push(item.toString());
        });
      }
      this.down(b);
    },
    downOne: function(record) {
      let b = [];
      b.push(record.hao.toString());
      this.down(b);
    },
    down(_arr) {
      HAO_down({
        haoList: _arr
      })
        .then(() => {
          this.$notification.success({
            message: "提示",
            description: "下架成功"
          });
          this.confirmLoading = false;
          this.visible = false;
          this.visibleDown = false;
          if (
            (this.total - _arr.length) % this.limit === 0 &&
            (this.total - _arr.length) / this.limit === this.current - 1
          ) {
            this.getHao({
              skip: (this.current - 2) * this.limit,
              limit: this.limit,
              hao: this.searchValue
            });
          } else {
            this.getHao({
              skip: (this.current - 1) * this.limit,
              limit: this.limit,
              hao: this.searchValue
            });
          }
        })
        .catch(() => {
          this.confirmLoading = false;
          this.$notification.success({
            message: "提示",
            description: "err"
          });
        });
    },
    onSearch: function(value) {
      this.searchValue = value;
      this.getHao({
        skip: 0,
        limit: 10,
        hao: this.searchValue
      });
    },
    onChange: function(page, pageSize) {
      this.current = (page - 1) * pageSize;
      this.limit = pageSize;
      this.getHao({
        skip: this.current,
        limit: this.limit,
        hao: this.searchValue
      });
    },
    change: function(_data) {
      //翻页
      let _skip = (_data.current - 1) * _data.pageSize;
      this.getHao({
        limit: this.pagination.pageSize,
        skip: _skip,
        hao: this.searchValue
      });
    },
    showDetail: function(e) {
      this.visibleDetail = true;
      this.haoDetail = e;
    }
  }
};
</script>

<style lang="less" scoped>
.trading-box {
  .head-opera-box {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px;
  }
  .opera-btn-box {
    a {
      margin: 0 5px;
    }
  }
  .pagination-box {
    display: flex;
    justify-content: flex-end;
    padding: 10px 5px;
  }
}
</style>
